import React from 'react'
import HeroForm from '../HeroForm/HeroForm'
import styles from './HeroSection.module.css'
import logo from '../../assets/images/logo.svg'

// Note: Background image is handled in CSS, but check if Vite resolves it correctly in CSS Modules. 
// If not, we might need inline style or import. 
// Vite resolves relative URLs in CSS files.

export const HeroSection = () => {
    return (
        <section className={styles.heroSection}>
            <div className={styles.heroBackground}>
                {/* Background image set via CSS */}
            </div>

            <div className={styles.contentContainer}>
                <div className={styles.logoWrapper}>
                    <img src={logo} alt="TrustedOnlineLoans" className={styles.heroLogo} />
                </div>

                <div className={styles.formWrapper}>
                    <HeroForm />
                </div>
            </div>
        </section>
    )
}

export default HeroSection
